enum ESortDirection {
  DESC = 'desc',
  ASC = 'asc',
}

export default ESortDirection;
